exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-error{color:#e04141}.label-success{color:#95dd51}#order-error{position:fixed;display:block;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:2;cursor:pointer}.order-error-body{margin-left:20%;padding:20px;margin-right:20%;background-color:#fff;margin-top:45vh}.order-error-body-mobile{margin:30vh 13vw;padding:5vw;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28f49a51","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/OrderError.vue
// module id = 425
// module chunks = 0